<template>
    <!-- <app-layout> -->



    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">



        <div class="md:grid md:grid-cols-3 md:gap-6 mt-6">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Security
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Comply with your security and privacy requirements.
                    </p>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex">

                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">

                    <server-location :plan_custom_s3_bucket="plan_custom_s3_bucket" :bucket="bucket"
                        :birdie_buckets="birdie_buckets"></server-location>

                    <jet-section-border />

                    <auto-delete :tags="tags"></auto-delete>

                    <jet-section-border />

                    <blur-data :w_settings="widget_settings"></blur-data>

                    <jet-section-border />

                    <gdpr :w_settings="widget_settings"></gdpr>

                </div>

            </div>



            <div class="col-span-3 mt-12">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Recordings Privacy Settings
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Guard your videos with an extra layer of privacy
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 col-span-3 flex">

                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 w-full border border-gray-200">

                    <recordings-access v-if="!restrict_incoming_videos"></recordings-access>

                    <jet-section-border v-if="!restrict_incoming_videos" />

                    <secure-sharing></secure-sharing>

                    <jet-section-border />

                    <admin-sent-view></admin-sent-view>

                </div>

            </div>





            <div class="col-span-3 mt-12">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        SSO
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Access to Birdie with your Identity Provider
                    </p>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex">

                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 w-full border border-gray-200">

                    <saml :saml_tenant_initial="saml_tenant" :saml_uuid="saml_uuid" :plan_sso="plan_sso"></saml>

                </div>

            </div>



        </div>



    </div>


</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import AutoDelete from '@/Components/Settings/Security/AutoDelete'
import BlurData from '@/Components/Settings/Security/BlurData'
import ServerLocation from '@/Components/Settings/Security/ServerLocation'
import RecordingsAccess from '@/Components/Settings/Security/RecordingsAccess'
import AdminSentView from '@/Components/Settings/Security/AdminSentView'
import SecureSharing from '@/Components/Settings/Security/SecureSharing'
import Gdpr from '@/Components/Settings/Security/Gdpr'
import Saml from '@/Components/Settings/Security/Saml'

export default {
    props: ["widget_settings", "tags", "saml_tenant", "saml_uuid", "plan_sso", "plan_custom_s3_bucket", "bucket", "birdie_buckets", "restrict_incoming_videos"],
    components: {
        AppLayout, JetSectionBorder, Saml, RecordingsAccess,
        AutoDelete, BlurData, ServerLocation, Gdpr,
        SecureSharing, AdminSentView
    },
    layout: AppLayout,
    data() {
        return {
        }
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>
